import { LocalDate } from '@js-joda/core';

import { Country } from '@dreryk/address-common-api';
import { Passport } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

import { StyledPassportField } from './PassportField.styled';

type PassportFormBeanPart = {
   passport?: string | null;
   passportCountry?: Country | null;
   passportValidTo?: LocalDate | null;
};
type PassportFieldProps = Pick<FormContextValues<PassportFormBeanPart>, 'register'>;

export const PassportField = (props: PassportFieldProps): JSX.Element => {
   return (
      <StyledPassportField>
         <TextInput
            controller={props.register('passport', {
               required: true,
               maxLength: Passport.MAX_LENGTH,
               pattern: {
                  value: new RegExp(Passport.PATTERN, 'u'),
                  message: patientTranslationKeys.invalidPassportPattern,
               },
               validate: (value) =>
                  Passport.isValueValid(value as string) ? undefined : patientTranslationKeys.invalidPassport,
            })}
            label={patientTranslationKeys.personalIdentifier}
            placeholder={patientTranslationKeys.serialAndPassportNumber}
            testId={'passport'}
            defaultValue={null}
         />
      </StyledPassportField>
   );
};
